export class FormaPago {
  idformapago?: number;
  codigo?: string;
  nombre?: string;
  requiere_banco?: boolean;
  requiere_numope?: boolean;
  editando?: boolean;
  constructor() { this.requiere_banco = false; this.requiere_numope = false; }
}
